import angular from "angular";

angular
    .module('app')
    .component('groupCurriculumControl', {
        template: require('./group-curriculum-control.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'ErrorResponseParser', controller],
        bindings: {
            group: '<',
            course: '<',
        }
    });

function controller($http, Notifier, $uibModal, ErrorResponseParser) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.search = null;

    $ctrl.selectedStudents = [];

    $ctrl.$onInit = function () {
        $ctrl.activeLesson = $ctrl.course.chapters[0].lessons[0];
        $ctrl.getStudents();
    };

    $ctrl.getStudents = function () {
        $http
            .get(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/get-students`, {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    search: $ctrl.search,
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;
                    $ctrl.total = response.data.total;
                    $ctrl.students.forEach(function (student, ind) {
                        student.number = ($ctrl.page - 1) * $ctrl.perPage + ind + 1;
                        setStudentActiveLessonStatus(student);
                    });
                }
            );
    };

    function setStudentActiveLessonStatus(student) {
        student.activeLessonStatus = null;
        student.activeLessonCanOpen = null;

        let studentLessonStatus = null;

        for (let i = 0; i < student.lesson_statuses.length; i++) {
            if (student.lesson_statuses[i].lesson_id == $ctrl.activeLesson.id) {
                studentLessonStatus = student.lesson_statuses[i];
                break;
            }
        }

        student.activeLessonStatus = studentLessonStatus ? studentLessonStatus.status : null;
        student.activeLessonCanOpen = studentLessonStatus ? !!studentLessonStatus.can_open : null;
    }

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getStudents();
    };

    $ctrl.resetFilter = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.getStudents();
    };

    $ctrl.perPageChanged = function () {
        $ctrl.page = 1;
        $ctrl.getStudents();
    };

    $ctrl.selectLesson = function (lesson) {
        if ($ctrl.updateLoading) {
            alert('Идет обновление. Переключите урок позже');
            return;
        }
        $ctrl.activeLesson = lesson;
        $ctrl.students.forEach(function (student) {
            setStudentActiveLessonStatus(student);
        });
    };

    $ctrl.updateLessonAccessForStudent = function (student) {
        if ($ctrl.updateLoading) {
            return;
        }

        $ctrl.updateLoading = true;

        $http
            .post(`/admin/users/${student.id}/update-lesson-access`, {
                lesson_id: $ctrl.activeLesson.id,
                can_open: student.activeLessonCanOpen
            })
            .then(
                function (response) {
                    $ctrl.updateLoading = false;

                    if (student.activeLessonCanOpen) {
                        $ctrl.activeLesson.can_open++;
                        $ctrl.activeLesson.can_not_open--;
                    } else {
                        $ctrl.activeLesson.can_open--;
                        $ctrl.activeLesson.can_not_open++;
                    }
                },
                function (error) {
                    $ctrl.updateLoading = false;
                    ErrorResponseParser.parse(error);
                    student.activeLessonCanOpen = !student.activeLessonCanOpen;
                }
            );
    };

    $ctrl.openForAll = function () {
        doActionForAll('open', $ctrl.activeLesson);
    };

    $ctrl.closeForAll = function () {
        doActionForAll('close', $ctrl.activeLesson);
    };

    function doActionForAll(action, lesson) {

        if ($ctrl.updateLoading) {
            return;
        }

        $ctrl.updateLoading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-lesson-access`, {
                lesson_id: lesson.id,
                action: action
            })
            .then(
                function () {

                    $ctrl.updateLoading = false;

                    $ctrl.students.forEach(function (student) {
                        let lessonStatus = student.lesson_statuses.find(v => v.lesson_id == lesson.id);
                        if (lessonStatus) {
                            lessonStatus.can_open = action == 'open';
                        }
                        setStudentActiveLessonStatus(student);
                    });

                    if (action == 'open') {
                        $ctrl.activeLesson.can_open = $ctrl.group.students_count;
                        $ctrl.activeLesson.can_not_open = 0;
                    } else {
                        $ctrl.activeLesson.can_open = 0;
                        $ctrl.activeLesson.can_not_open = $ctrl.group.students_count;
                    }
                },
                function (error) {
                    $ctrl.updateLoading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    }

}
